// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-scrollbar__wrap {\n  overflow-x: hidden;\n}\n.iframesStatus {\n  margin-left: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
